var _g, _g2, _rect, _path, _path2, _g3, _rect2, _path3, _path4, _g4, _rect3, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _circle, _rect8, _path5, _rect9, _rect10, _g8, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyTradingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 174,
    viewBox: "0 0 200 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1877_14657)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.6892,
    cy: 86.6892,
    r: 26.6892,
    fill: "#8A23FF",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1877_14657)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.215,
    y: 112.219,
    width: 27.8989,
    height: 27.4587,
    rx: 6,
    transform: "rotate(-47 107.215 112.219)",
    fill: "white",
    fillOpacity: 0.36
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 136.2,
    y: 42.2,
    width: 29.6,
    height: 29.6,
    rx: 6.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166 57H194.5",
    stroke: "url(#paint0_linear_1877_14657)",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 83V49",
    stroke: "url(#paint1_linear_1877_14657)",
    strokeWidth: 0.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_1877_14657_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.000346613 0.00207968 -0.00207968 -0.000346613 185.425 57.0797)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1806.63,
    height: 1788.95,
    fill: "url(#paint2_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1806.63,
    height: 1788.95,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1806.63,
    height: 1788.95,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1806.63,
    height: 1788.95,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 185.281,
    y: 55,
    width: 3.17261,
    height: 3.17261,
    rx: 0.5,
    transform: "rotate(46 185.281 55)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"transform\":{\"m00\":-0.69322687387466431,\"m01\":-4.159362792968750,\"m02\":187.85174560546875,\"m10\":4.159362792968750,\"m11\":-0.69322687387466431,\"m12\":55.346614837646484},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.5 158H170",
    stroke: "white",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127 144V173",
    stroke: "url(#paint3_linear_1877_14657)",
    strokeWidth: 0.4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_1877_14657_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00204584 -0.000267972 -0.000267972 -0.00204584 127.029 158.368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1821.12,
    height: 1803.44,
    fill: "url(#paint4_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1821.12,
    height: 1803.44,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1821.12,
    height: 1803.44,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1821.12,
    height: 1803.44,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.10482,
    height: 3.10482,
    rx: 0.5,
    transform: "matrix(0.694658 0.71934 0.71934 -0.694658 125 158.156)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"transform\":{\"m00\":4.0916852951049805,\"m01\":-0.53594309091567993,\"m02\":125.25120544433594,\"m10\":-0.53594309091567993,\"m11\":-4.0916852951049805,\"m12\":160.682128906250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 143.2,
    width: 29.6,
    height: 29.6,
    rx: 6.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint5_diamond_1877_14657_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00612496 0.00397768 0.00397757 -0.00612504 58.2275 158.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    fill: "url(#paint5_diamond_1877_14657)",
    opacity: 0.48,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(1 -1)",
    fill: "url(#paint5_diamond_1877_14657)",
    opacity: 0.48,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(-1 1)",
    fill: "url(#paint5_diamond_1877_14657)",
    opacity: 0.48,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(-1)",
    fill: "url(#paint5_diamond_1877_14657)",
    opacity: 0.48,
    shapeRendering: "crispEdges"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1441,
    height: 14.1439,
    rx: 3,
    transform: "matrix(0.190809 0.981627 0.981627 -0.190809 49.7109 152.406)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.30360645055770874},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.30360645055770874},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"transform\":{\"m00\":12.249926567077637,\"m01\":7.9551358222961426,\"m02\":48.125011444091797,\"m10\":7.9553589820861816,\"m11\":-12.250082969665527,\"m12\":160.21220397949219},\"opacity\":0.47999998927116394,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint6_diamond_1877_14657_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00730351 1.42862e-08 -1.35754e-08 -0.00730352 58.2249 157.931)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    fill: "url(#paint6_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(1 -1)",
    fill: "url(#paint6_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(-1 1)",
    fill: "url(#paint6_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1593.61,
    height: 1572.07,
    transform: "scale(-1)",
    fill: "url(#paint6_diamond_1877_14657)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1446,
    height: 14.1445,
    rx: 3,
    transform: "matrix(0.694658 0.71934 0.71934 -0.694658 48 157.824)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.30360645055770874},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.30360645055770874},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"transform\":{\"m00\":14.607029914855957,\"m01\":-2.7150814275955781e-05,\"m02\":50.921421051025391,\"m10\":2.8572319934028201e-05,\"m11\":-14.607031822204590,\"m12\":165.234863281250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2,
    y: 88.2,
    width: 29.6,
    height: 29.6,
    rx: 6.8,
    stroke: "white",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7734 103.578V107.023",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5 99.4453V107.025",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2266 103.578V107.023",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 96.5,
    width: 14,
    height: 12.7814,
    rx: 3.5,
    stroke: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 170.2,
    y: 143.2,
    width: 29.6,
    height: 29.6,
    rx: 6.8,
    stroke: "white",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint7_angular_1877_14657_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0075 -2.16272e-10 2.1627e-10 0.0075 184.5 158.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1133.33,
    y: -1133.33,
    width: 2266.67,
    height: 2266.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(201, 129, 254, 1) 0deg,rgba(86, 53, 253, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 158.5,
    r: 7.5,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.33827823400497437,\"g\":0.21051235496997833,\"b\":0.99453127384185791,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.33827823400497437,\"g\":0.21051235496997833,\"b\":0.99453127384185791,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":15.0,\"m01\":4.3254095771771972e-07,\"m02\":177.0,\"m10\":-4.3254325987618358e-07,\"m11\":15.0,\"m12\":151.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 170.2,
    y: 83.2,
    width: 29.6,
    height: 29.6,
    rx: 6.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.775 91.0278L179.021 96.7986C178.644 97.1768 178.911 97.8222 179.446 97.8222H181.486C181.817 97.8222 182.086 98.0909 182.086 98.4222V104.513C182.086 105.053 182.743 105.318 183.118 104.93L190.02 97.772C190.387 97.391 190.117 96.7556 189.588 96.7556H186.4C186.069 96.7556 185.8 96.4869 185.8 96.1556V91.4514C185.8 90.9165 185.153 90.649 184.775 91.0278Z",
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 94.2,
    y: 79.2,
    width: 64.6,
    height: 64.6,
    rx: 8.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98.35,
    y: 84.35,
    width: 55.3,
    height: 54.3,
    rx: 8.65,
    fill: "#7600FC",
    fillOpacity: 0.08,
    stroke: "url(#paint8_linear_1877_14657)",
    strokeWidth: 0.7
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1877_14657)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 111.492,
    width: 27.7291,
    height: 27.7291,
    rx: 6,
    transform: "rotate(-45 107.16 111.492)",
    fill: "url(#paint9_radial_1877_14657)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.111 119.252H119.889C119.388 119.252 118.907 119.056 118.553 118.707C118.199 118.358 118 117.885 118 117.392V109.02C118 108.527 118.199 108.054 118.553 107.705C118.907 107.356 119.388 107.16 119.889 107.16H133.111C133.612 107.16 134.093 107.356 134.447 107.705C134.801 108.054 135 108.527 135 109.02V117.392C135 117.885 134.801 118.358 134.447 118.707C134.093 119.056 133.612 119.252 133.111 119.252Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.75 113.668C130.624 113.668 130.504 113.619 130.416 113.532C130.327 113.445 130.277 113.327 130.277 113.203C130.277 113.08 130.327 112.962 130.416 112.874C130.504 112.787 130.624 112.738 130.75 112.738C130.875 112.738 130.995 112.787 131.083 112.874C131.172 112.962 131.222 113.08 131.222 113.203C131.222 113.327 131.172 113.445 131.083 113.532C130.995 113.619 130.875 113.668 130.75 113.668Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.167 107.159V105.86C132.167 105.575 132.1 105.293 131.972 105.038C131.844 104.782 131.658 104.559 131.428 104.385C131.199 104.211 130.932 104.092 130.648 104.036C130.364 103.98 130.071 103.989 129.791 104.063L119.403 106.791C119 106.896 118.645 107.13 118.391 107.455C118.137 107.78 118 108.179 118 108.589V109.019",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14657",
    x: 0,
    y: 0,
    width: 173.379,
    height: 173.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_1877_14657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14657",
    x: 74.0953,
    y: 58.693,
    width: 105.348,
    height: 105.372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.8,
    result: "effect1_foregroundBlur_1877_14657"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_1877_14657_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.281,
    y: 55,
    width: 3.17261,
    height: 3.17261,
    rx: 0.5,
    transform: "rotate(46 185.281 55)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_1877_14657_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.10482,
    height: 3.10482,
    rx: 0.5,
    transform: "matrix(0.694658 0.71934 0.71934 -0.694658 125 158.156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint5_diamond_1877_14657_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1441,
    height: 14.1439,
    rx: 3,
    transform: "matrix(0.190809 0.981627 0.981627 -0.190809 49.7109 152.406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint6_diamond_1877_14657_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1446,
    height: 14.1445,
    rx: 3,
    transform: "matrix(0.694658 0.71934 0.71934 -0.694658 48 157.824)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint7_angular_1877_14657_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 158.5,
    r: 7.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1877_14657",
    x: 109.645,
    y: 94.3711,
    width: 45.2461,
    height: 39.2422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360781 0 0 0 0 0.256029 0 0 0 0 0.898828 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1877_14657"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_14657",
    x1: 213.193,
    y1: 57.5,
    x2: 166,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_14657",
    x1: 185.5,
    y1: 35.0022,
    x2: 185.5,
    y2: 82.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_1877_14657",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128086,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786597,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_14657",
    x1: 126.16,
    y1: 187.193,
    x2: 126.16,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_1877_14657",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128086,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786597,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_diamond_1877_14657",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303606,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983768,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_diamond_1877_14657",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303606,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983768,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1877_14657",
    x1: 126,
    y1: 84,
    x2: 126.303,
    y2: 156.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37141,
    stopColor: "#6E5BCF",
    stopOpacity: 0.685054
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755379,
    stopColor: "#686288",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1877_14657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.025 125.357) rotate(109.81) scale(19.3468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57375,
    stopColor: "#C26EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785EFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTradingIcon);
export default __webpack_public_path__ + "static/media/CopyTradingIcon.fd3e02a0512b0bdfcb0c59ba01de91e9.svg";
export { ForwardRef as ReactComponent };